import { Theme } from '@mui/material';

type ValueType =
	| number
	| string
	| { xs?: number | string; sm?: number | string; md?: number | string; lg?: number | string; xl?: number | string };

export const commonStyles = (theme: Theme) => ({
	cursorPointer: {
		cursor: 'pointer',
	},
	visibilityHidden: {
		visibility: 'hidden',
	},
	visibilityVisible: {
		visibility: 'visible',
	},
	hidden: {
		display: 'none',
	},
	visible: {
		display: 'block',
	},
	block: {
		display: 'block',
	},
	inlineBlock: {
		display: 'inline-block',
	},

	relative: {
		position: 'relative',
	},
	absolute: {
		position: 'absolute',
	},
	fixed: {
		position: 'fixed',
	},
	sticky: {
		position: 'sticky',
	},

	flex: {
		display: 'flex',
	},
	flexRow: {
		display: 'flex',
		flexFlow: 'row nowrap',
	},
	flexRowWrap: {
		display: 'flex',
		flexFlow: 'row wrap',
	},
	flexColumn: {
		display: 'flex',
		flexFlow: 'column nowrap',
	},
	flexColumnWrap: {
		display: 'flex',
		flexFlow: 'column wrap',
	},

	flexCenter: {
		justifyContent: 'center',
		alignItems: 'center',
	},
	flexGrow1: {
		flexGrow: 1,
	},
	flexShrink0: {
		flexShrink: 0,
	},
	contentCenter: {
		justifyContent: 'center',
	},
	itemsCenter: {
		alignItems: 'center',
	},
	contentBetween: {
		justifyContent: 'space-between',
	},
	itemsBetween: {
		alignItems: 'space-between',
	},
	contentAround: {
		justifyContent: 'space-around',
	},
	itemsAround: {
		alignItems: 'space-around',
	},
	contentEvenly: {
		justifyContent: 'space-evenly',
	},
	itemsEvenly: {
		alignItems: 'space-evenly',
	},
	contentStart: {
		justifyContent: 'flex-start',
	},
	itemsStart: {
		alignItems: 'flex-start',
	},
	contentEnd: {
		justifyContent: 'flex-end',
	},
	itemsEnd: {
		alignItems: 'flex-end',
	},
	contentStretch: {
		justifyContent: 'stretch',
	},
	itemsStretch: {
		alignItems: 'stretch',
	},
	alignSelfStart: {
		alignSelf: 'flex-start',
	},
	alignSelfEnd: {
		alignSelf: 'flex-end',
	},
	alignSelfCenter: {
		alignSelf: 'center',
	},
	alignSelfStretch: {
		alignSelf: 'stretch',
	},

	fullWidth: {
		width: '100%',
	},

	m: (size: ValueType) => ({
		margin: size,
	}),
	mt: (size: ValueType) => ({
		marginTop: size,
	}),
	mr: (size: ValueType) => ({
		marginRight: size,
	}),
	mb: (size: ValueType) => ({
		marginBottom: size,
	}),
	ml: (size: ValueType) => ({
		marginLeft: size,
	}),

	p: (size: ValueType) => ({
		padding: size,
	}),
	pt: (size: ValueType) => ({
		paddingTop: size,
	}),
	pr: (size: ValueType) => ({
		paddingRight: size,
	}),
	pb: (size: ValueType) => ({
		paddingBottom: size,
	}),
	pl: (size: ValueType) => ({
		paddingLeft: size,
	}),
	px: (size: ValueType) => ({
		paddingLeft: size,
		paddingRight: size,
	}),
	py: (size: ValueType) => ({
		paddingTop: size,
		paddingBottom: size,
	}),

	gap: (size: ValueType) => ({
		gap: size,
	}),
	rowGap: (size: ValueType) => ({
		rowGap: size,
	}),
	columnGap: (size: ValueType) => ({
		columnGap: size,
	}),

	fontSize: (size: ValueType) => ({
		fontSize: size,
	}),
	fontSmallest: {
		fontSize: { xs: '8px', sm: '10px', md: '12px', lg: '14px', xl: '16px' },
	},
	fontSmall: {
		fontSize: { xs: '10px', sm: '12px', md: '14px', lg: '16px', xl: '18px' },
	},
	fontMedium: {
		fontSize: { xs: '12px', sm: '14px', md: '16px', lg: '18px', xl: '20px' },
	},
	fontLarge: {
		fontSize: { xs: '14px', sm: '16px', md: '18px', lg: '20px', xl: '22px' },
	},

	fontWeight: (weight: ValueType) => ({
		fontWeight: weight,
	}),

	showOnMobileWidth(display = 'block') {
		return {
			display: 'none',
			[theme.breakpoints.down('sm')]: {
				display,
			},
		};
	},
	hideOnMobileWidth: {
		[theme.breakpoints.down('sm')]: {
			display: 'none',
		},
	},
});
